<template>
  <card>
    <template slot="header">
      <div class="d-flex justify-content-between">
        <h4 class="card-title">Stammdaten</h4>
        <router-link :to="`/products/${product.id}/edit`" class="btn btn-fill btn-primary">
          Bearbeiten
        </router-link>
      </div>
    </template>
    <fg-input label="Name">
      <p class="form-control-static">{{ product.name }}</p>
    </fg-input>
    <fg-input label="Kurzbezeichnung">
      <p class="form-control-static">{{ product.short_name }}</p>
    </fg-input>
    <fg-input label="Produktkategorie">
      <p class="form-control-static">{{ product.product_category ? product.product_category.name : '' }}</p>
    </fg-input>
    <fg-input label="PZN">
      <p class="form-control-static">{{ product.pzn }}</p>
    </fg-input>
    <fg-input label="Hersteller">
      <p class="form-control-static">{{ product.hersteller }}</p>
    </fg-input>
    <fg-input label="Einheit">
      <p class="form-control-static">{{ product.unit ? product.unit.name : '' }}</p>
    </fg-input>
    <div class="row">
      <div class="col-sm-9">
      <fg-input label="Einheiten/Pkg">
        <p class="form-control-static">{{ product.stk_pkg }}</p>
      </fg-input>
      </div>
      <div v-if="product.stk_pkg !== 0 && product.stk_pkg !== 1" class="col-sm-3">
        <fg-input label="Preis/Einheit">
      <p class="form-control-static">{{ unitPrice(product.standard_price, product.stk_pkg) | priceFromCentEuro}} </p>
    </fg-input>
      </div>

    </div>

    <fg-input label="Größe">
      <p class="form-control-static">{{ product.size }}</p>
    </fg-input>
    <fg-input label="Standard Einkaufspreis (netto)">
      <p class="form-control-static">{{ product.standard_price | priceFromCentEuro }}</p>
    </fg-input>
    <div class="row">
      <div class="col-sm-9">
        <fg-input label="Verkaufspreis (brutto)">
          <p class="form-control-static">{{ product.price | priceFromCentEuro }}</p>
        </fg-input>
      </div>
      <div class="col-sm-3">
        <fg-input label="Ust">
          <p class="form-control-static">{{ product.tax | formatTax }}</p>
        </fg-input>
      </div>
    </div>
    <fg-input label="Warnschwelle">
      <p class="form-control-static">{{ product.warnschwelle }}</p>
    </fg-input>
    <fg-input label="Lager Sollmenge">
      <p class="form-control-static">{{ product.lager_soll_menge }}</p>
    </fg-input>
    <fg-input label="Barcode">
      <p class="form-control-static">{{ product.barcode }}</p>
    </fg-input>
    <fg-input label="Barcode 2">
      <p class="form-control-static">{{ product.barcode_2 }}</p>
    </fg-input>
    <fg-input label="Nächstes Ablaufdatum">
      <p class="form-control-static">{{ product.next_expiry_date | date }}</p>
    </fg-input>
    <fg-input label="Barcode typ">
      <p class="form-control-static">{{ product.barcode_type }}</p>
    </fg-input>
    <fg-input label="Hat Ablaufdatum">
      <p class="form-control-static">{{ product.has_ablaufdatum ? 'Ja' : 'Nein' }}</p>
    </fg-input>
    <fg-input label="Sammelprodukt">
      <p class="form-control-static">{{ product.is_collective ? 'Ja' : 'Nein' }}</p>
    </fg-input>

    <fg-input label="Kostenstelle erforderlich">
      <p class="form-control-static">{{ product.kostennelle_req ? 'Ja' : 'Nein' }}</p>
    </fg-input>
    <!-- <fg-input label="Kostenstelle">
      <p class="form-control-static">{{ product.cost_center ? product.cost_center.name : '' }}</p>
    </fg-input> -->
    <fg-input label="Buchhaltungs-Konto">
      <p class="form-control-static">{{ product.accounting_number }}</p>
    </fg-input>
    <fg-input label="EAN / Artikelnummer">
      <p class="form-control-static">{{ product.referenznummer }}</p>
    </fg-input>
    <fg-input label="Lagerort">
      <p class="form-control-static">{{ product.storage_location }}</p>
    </fg-input>
    <fg-input label="Regal">
      <p class="form-control-static">{{ product.regal }}</p>
    </fg-input>
    <fg-input label="Regal 2">
      <p class="form-control-static">{{ product.regal_2 }}</p>
    </fg-input>
    <fg-input label="Kommentar">
      <p class="form-control-static" style="white-space: break-spaces;">{{ product.comment }}</p>
    </fg-input>
    <button class="btn btn-danger btn-fill float-right"
      @click="$emit('deleteProduct')"
    >
      <i class="fa fa-close"></i> Löschen
    </button>
  </card>
</template>

<script>
export default {
  props: ['product'],
  methods: {
    unitPrice (price, stk_pkg) {
      return (price / stk_pkg)
    },
  }
}

</script>

<style>
</style>
